export interface PersonType {
  trader: boolean;
  partner: boolean;
  tp: boolean;
  investor: boolean;
  exchanger: boolean;
}

export enum EventType {
  PageView = 'Pageview',

  // GA360
  UAEvent = 'UAevent',
  ViewCertificate = 'View certificate',
  Error = 'error',
  Transaction = 'transaction',
  QualifiedLead = 'qualifiedlead',
  TpOpenAccount = 'web_tp_open_account',

  // GA4
  InteractiveClick = 'interactive_click',
  LeavePaymentSystemList = 'methodsScreen_closed',
  SelectPaymentSystem = 'methodsItem_tapped',
  FilterPaymentSystem = 'searchScreen_viewed',
  SearchInputUpdated = 'searchInput_updated',
  ABTestViewed = 'abtest_viewed',
  FocusPaymentSystemSearch = 'searchInput_tapped',
  IDInputUpdated = 'idInput_updated',
  IDWarningViewed = 'idWarning_viewed',
  BirthdateInputUpdated = 'birthdateInput_updated',
  FileUploadTapped = 'fileUpload_tapped',
  FileUploadStarted = 'fileUpload_started',
  FileUploadFinished = 'fileUpload_finished',
  FormSuggestionTapped = 'formSuggestion_tapped',
  ConfirmButtonTapped = 'confirmButton_tapped',
  FilterButtonTapped = 'filterButton_tapped',
  DepositButtonTapped = 'depositButton_tapped',
  DialogScreenViewed = 'dialogScreen_viewed',
  PaymentFormClosed = 'paymentForm_closed',
  Login = 'login',
  SignUp = 'sign_up',
  ChangeLanguage = 'change_language',
  EuAgreementButtonTapped = 'euAgreementButton_tapped',

  //Partner Area GA4
  BecomePartnerButtonTapped = 'becomePartnerButton_tapped',
  CopyButtonTapped = 'copyButton_tapped',
  SetButtonTapped = 'setButton_tapped',
  CreateButtonTapped = 'createButton_tapped',
  PopupView = 'popup_view',
  DownloadButtonTapped = 'downloadButton_tapped',
  PwaBlockViewed = 'pwaBlock_viewed',
  PwaBlockClosed = 'pwaBlock_closed',
  DownloadApkTapped = 'downloadApk_tapped',
  PwaLogin = 'pwa_login',
  ClosePartnerButtonTappded = 'closePartnerButton_tapped',
  PageSpeed = 'pageSpeed',

  // Deposit bonus
  GetVerifiedTapped = 'get_verified_tapped',
  DepositBonusDialogViewed = 'deposit_bonus_dialog_viewed',
  DepositFromBonusTapped = 'deposit_from_bonus_tapped',
  BannerDepositBonusViewed = 'banner_deposit_bonus_viewed',
  AlertDepositBonusViewed = 'alert_deposit_bonus_viewed',
  ExpiredDepositBonusViewed = 'expired_deposit_bonus_viewed',
  TermsDepositBonusViewed = 'terms_deposit_bonus_viewed',

  // Promocode
  PromoCodeRewardsHubViewed = 'promo_code_rewards_hub_viewed',
  ApplyPromoCodeButtonTapped = 'apply_promo_code_button_tapped',
  PromoCodeInputTapped = 'promo_code_input_tapped',
  PromoCodeCheckTapped = 'promo_code_check_tapped',
  PromoCodeActivateTapped = 'promo_code_activate_tapped',
  PromoCodeSuccessViewed = 'promo_code_success_viewed',
  PromoCodeErrorViewed = 'promo_code_error_viewed',
  PromoCodeWarningViewed = 'promo_code_warning_viewed',
  PromoDeleteButtonTapped = 'promo_delete_button_tapped',
  ConfirmPromoDeleteButtonTapped = 'confirm_promo_delete_button_tapped'
}

export enum EventPage {
  VerificationId = 'verification id',
  Operators = 'operators',
  PaymentForm = 'payment form',
  PaymentSystemsList = 'payment systems list',
}

export interface GtmEvent {
  event: string;
}

// GTM event for legacy Google Analytics 360 (Universal)
export interface GA360Event {
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: string;
  eventInteraction?: string;
  transactionValue?: string;
  transactionId?: string;
}

// GTM event for newer Google Analytics 4
export interface GA4Event {
  context: GA4Context;
  object: string;
  action: GA4Action;

  [key: string]: unknown;
}

export type GA4Context =
  | 'welcome'
  | 'login'
  | 'registration'
  | 'account_details'
  | 'signup'
  | 'resetPass'
  | 'new'
  | 'performance'
  | 'certificate'
  | 'dashboard'
  | 'account'
  | 'finances'
  | 'deposit'
  | 'withdrawal'
  | 'vrfEmail'
  | 'vrfId'
  | 'vrfPhone'
  | 'more'
  | 'profile'
  | 'notify'
  | 'calendar'
  | 'promo'
  | 'nps'
  | 'security'
  | 'chat'
  | 'error'
  | 'siteForm'
  | 'menu'
  | 'sitePopup'
  | 'abTest'
  | 'verifyId'
  | 'partnerReffLink'
  | 'partnerRebate'
  | 'partnerAdvMaterial'
  | 'ID'
  | 'grade'
  | 'partnerAdvMaterialSocialMedia'
  | 'pwa'
  | 'popup_language_selector'
  | 'deposit_bonus'
  | 'rewards_hub'
  | 'promo_code';

export type GA4Action =
  | 'viewed'
  | 'closed'
  | 'tapped'
  | 'click'
  | 'updated'
  | 'swiped'
  | 'scrolled'
  | 'started'
  | 'completed'
  | 'created'
  | 'sent'
  | 'changed'
  | 'verified'
  | 'connected'
  | 'disconnected'
  | 'registered'
  | 'screenshooted'
  | 'finished'
  | 'signedIn';

export interface DataLayer extends GtmEvent {
  user: {
    email_md5: string;
    email: string;
    name: string;
    id: string;
    auth_status: string;
    country: string;
    fb_phone_number: string;
    fb_country: string;
    client_id: string;
    language: string;
    person_type: PersonType;
    verifyemail: string; // 1 если да, 0 если нет
    verifyphone: string; // 1 если да, 0 если нет
    verifyid: string; // 1 если да, 0 если нет, EU ONLY
    verifypor: string; // 1 если да, 0 если нет, EU ONLY
    verifycard: string; // 1 если да, 0 если нет, EU ONLY
    tracking: {
      source: string; // источник регистрации
      medium: string; // канал регистрации
    };
  };
  regulated: 'IFSC';
  page: {
    isPwa: boolean;
    path: string;
    title: string;
    referrer: string; // document.referrer
  };
  userAgent: string; // navigator.userAgent
  isOnline: boolean; // navigator.online
}

export type ActionResultType = 'success' | 'fail';

export type DataLayerPushEvent = {
  event: EventType;
  data: GA360Event | GA4Event;
};
